import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Content, Sider } = Layout;

const graphs = [
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Evolución en el tiempo",
    text: `En el año 2006, únicamente el 10% de niñas y niños vivía en hogares nucleares monoparentales. Esta proporción 
          ha ido en aumento con el tiempo, alcanzando un 19% en 2017 y un 20% en 2024. Al mismo tiempo, el porcentaje 
          de niñas y niños que vivía en hogares nucleares biparentales era del 61% en 2006, cifra que ha disminuido 
          hasta el 57% en 2024.`,
    link: "https://public.flourish.studio/visualisation/20924071/embed",
  },
  {
    id: "graph2",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `No se observan diferencias entre niñas y niños en la estructura de los hogares en toda la línea de tiempo.`,
    link: "https://public.flourish.studio/visualisation/20924083/embed",
  },
  {
    id: "graph3",
    title: "Análisis por edad",
    menuTitle: "\u2022 Edad",
    text: `Entre el 2006 y el 2024 disminuyó la proporción de niñas y niños en hogares nucleares biparentales en la infancia media y en la 
          adolescencia. Contrario a la tendencia nacional, entre las niñas y los niños de la primera infancia aumentó la proporción que vive 
          en hogares nucleares biparentales. Por otro lado, la proporción de niñas y niños en hogares nucleares monoparentales aumentó en 
          todos los tramos etarios.`,
    link: "https://public.flourish.studio/visualisation/20924090/embed",
  },
  {
    id: "graph4",
    title: "Análisis por país de nacimiento",
    menuTitle: "\u2022 País de nacimiento",
    text: `De acuerdo al país de nacimiento de las niñas y los niños, se observan algunas diferencias en la estructura familiar. Niñas y niños 
          nacidos en otro país concentran una menor proporción en los hogares nucleares monoparentales que quienes nacieron en el país (13% y 
          20%, respectivamente). Estas brechas existen recién desde el año 2020, antes de esa medición las estructuras familiares según país 
          de origen no presentaban mayores diferencias.`,
    link: "https://public.flourish.studio/visualisation/20924096/embed",
  },
  {
    id: "graph5",
    title: "Análisis por pueblo originario",
    menuTitle: "\u2022 Pueblo originario",
    text: `A partir del 2024, se observan diferencias estadísticamente significativas entre las niñas y niños que se identifican con un pueblo 
          originario y aquellos que no lo hacen en su estructura familiar. Entre las niñas y niños que se identifican, hay una proporción más 
          alta viviendo en hogares nucleares monoparentales.`,
    link: "https://public.flourish.studio/visualisation/20924111/embed",
  },
  {
    id: "graph6",
    title: "Análisis por quintil de ingresos",
    menuTitle: "\u2022 Quintil de ingresos",
    text: `La evolución entre el primero , es decir, el de menores ingresos, y el cuarto quintil es similar en toda la serie de tiempo: la 
          cantidad de niñas y niños en hogares nucleares monoparentales se duplicó desde 2006. En el quinto quintil, sin embargo, no hubo mayores 
          variaciones en este tipo de estructura familiar. Entre los hogares extensos biparentales ocurre lo contrario. Entre las niñas y niños 
          de quintiles más altos ha disminuido los hogares extensos biparentales, mientras que en los quintiles más bajos se mantuvo estable esta 
          cifra. 

  En 2024, la proporción de niñas y niños en hogares nucleares monoparentales en el primer quintil es más del doble que en el último (28% y 
        12%, respectivamente). Respecto a los hogares nucleares biparentales, mientras que en el primer quintil la proporción de niñas y niños es 
        de 42%, en el quinto quintil es de 80%.`,
    link: "https://public.flourish.studio/visualisation/28025728/embed",
  },
  {
    id: "graph7",
    title: "Análisis por zona de residencia",
    menuTitle: "\u2022 Zona",
    text: `Entre las niñas y los niños que residen en zonas urbanas hay una mayor proporción en hogares nucleares monoparentales que entre niñas 
          y niños de zonas rurales. En 2024, la brecha entre ambos grupos es de 4 puntos porcentuales.`,
    link: "https://public.flourish.studio/visualisation/20924103/embed",
  },
  {
    id: "graph8",
    title: "Análisis por macrozona",
    menuTitle: "\u2022 Macrozona",
    text: `No se observan mayores diferencias en la estructura familiar en que viven niñas y niños de acuerdo a la macrozona en que residen. En 
          la Región Metropolitana se observa una proporción levemente inferior de niñas y niños en hogares nucleares monoparentales. En el Sur, 
          hay una proporción mayor de niñas y niños en hogares nucleares biparentales. En el Norte, hay una mayor presencia, aunque también 
          pequeña, de niñas y niños en hogares del tipo extenso monoparental que en el resto.`,
    link: "https://public.flourish.studio/visualisation/20924118/embed",
  },
  {
    id: "graph9",
    title: "Análisis por región",
    menuTitle: "\u2022 Región",
    text: `Las variaciones en la estructura familiar según la región de residencia de niñas y niños son poco significativas. Sin embargo, se 
          observan algunas diferencias regionales: Aysén presenta la mayor proporción de niñas y niños que viven en hogares nucleares 
          monoparentales; Magallanes concentra la mayor proporción en hogares nucleares biparentales; en Arica y Coquimbo registran la 
          proporción más alta de hogares extensos monoparentales; y Arica también destaca por tener la mayor proporción de niñas y niños que 
          viven en hogares extensos biparentales.`,
    link: "https://public.flourish.studio/visualisation/22836794/embed",
  }  
];


const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId, graphTitle) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu theme="dark" mode="vertical" selectedKeys={[selectedMenuItem]} style={{ background: "#fff" }}>
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{ color: 'black', paddingLeft: graph.id !== "graph1" ? "30px" : "20px" }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              <iframe
                src={selectedGraph.link}
                frameBorder="0"
                scrolling="no"
                style={{ minWidth: "100%", height: "500px" }}
              ></iframe>
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
